import React from 'react';
import moment from "moment/moment";

export const normalizeDate = date => {
  if (!date || date instanceof moment || date instanceof Date)
    return date;
  if (date.indexOf('T00:00:00Z') > -1)
    return moment(date.substr(0, date.length - 1));

  return moment.utc(date).utcOffset('-1000');
};

export const DateRenderer = ({value}) => {
  const date = normalizeDate(value);
  return date && date.year() > 1850 ?
    (<span>{date.format('MM/DD/YYYY')}</span>) :
    null;
};

export const autoRefreshCellRenderer = (Renderer) => {
  return class extends React.Component {
    refresh(params){
      console.log('refreshing cell renderer', params);
      return true;
    }
    render(){
      return <Renderer {...this.props}/>
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/CellRenderers.js